import { SUB_REFRESH_QTY } from "./types";

export const setSubRefreshQuantity = (bool) => ({
  type: SUB_REFRESH_QTY,
  payload: bool,
});
